@import './pk-popover.variables';

:host {
  @apply relative inline-block;
}

.pk-popover__panel {
  @apply fixed -z-10 flex w-[--popover-panel--width-s] p-[--popover-panel--padding];
  @apply rounded-[--popover-panel--border-radius] bg-[color:--popover-panel--background-color] bg-clip-border;
  @apply pointer-events-none opacity-0 transition-opacity duration-250 ease-in-out;

  box-shadow: var(--popover-panel--box-shadow);

  &.medium {
    @apply xs:w-[--popover-panel--width-m];
  }

  &.large {
    @apply sm:w-[--popover-panel--width-l];
  }

  &.open {
    @apply pointer-events-auto z-[900] opacity-100;
  }

  &.none,
  &.stroke {
    @apply shadow-none;
  }

  &.stroke {
    @apply border-[length:1px] border-solid border-[color:--popover-panel--stroke-color];
  }
}

.pk-popover__header {
  ::slotted(*) {
    @apply m-0 w-full p-0 font-bold text-m leading-m text-text-01;
  }
}

.pk-popover__body {
  ::slotted(*) {
    @apply font-regular text-s leading-m text-text-01;
  }
}

.pk-popover__arrow {
  &,
  &::before {
    @apply absolute z-[-1] box-border h-[--popover-arrow--size] w-[--popover-arrow--size];
  }

  &::before {
    @apply left-0 top-0 rotate-45 bg-[color:--popover-panel--background-color] content-[''];
  }

  &.stroke {
    &::before {
      @apply border-0 border-solid border-[color:--popover-panel--stroke-color];

      &[data-position^='bottom'] {
        @apply mt-[-1px] border-l-[length:1px] border-t-[length:1px];
      }

      &[data-position^='left'] {
        @apply ml-[1px] border-r-[length:1px] border-t-[length:1px];
      }

      &[data-position^='right'] {
        @apply ml-[-1px] border-b-[length:1px] border-l-[length:1px];
      }

      &[data-position^='top'] {
        @apply mt-[1px] border-b-[length:1px] border-r-[length:1px];
      }
    }
  }
}
